import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTrendingUpBars(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.083 19.75v-4.833a.5.5 0 0 0-.5-.5H5.205c-.804 0-1.455.65-1.455 1.454v2.425c0 .803.651 1.454 1.455 1.454zm0 0h5.334m-5.334 0v-9.212c0-.803.652-1.455 1.455-1.455h3.379a.5.5 0 0 1 .5.5V19.75m0 0h3.879c.803 0 1.454-.651 1.454-1.454V5.205c0-.804-.651-1.455-1.454-1.455H15.87c-.803 0-1.454.651-1.454 1.455z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTrendingUpBars);
export default ForwardRef;
